var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["icon", _vm.iconType, _vm.iconOptions] }, [
    _vm.icon === "check"
      ? _c("img", {
          attrs: {
            src: require("@/assets/images/ui/icon-check.svg"),
            alt: "green check icon"
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.icon === "x-red"
      ? _c("img", {
          attrs: {
            src: require("@/assets/images/ui/x-red.svg"),
            alt: "red x icon"
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.icon === "x-gray"
      ? _c("img", {
          attrs: {
            src: require("@/assets/images/ui/x-gray.svg"),
            alt: "gray x icon"
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.icon === "info"
      ? _c("img", {
          attrs: {
            src: require("@/assets/images/ui/icon-info.svg"),
            alt: "blue info icon"
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcf08158", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcf08158","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Icon.vue
// module id = null
// module chunks = 